import { CUSTOMIZE_COLUMNS_CHECKBOX } from '../../screens/Products/RcuDashboard/AdminTransactions/components/AdminTransactionTable/contsants';

import actionConstants from '../constants/';

const adminRcuMerchant = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminRcuMerchantData: [],
  message: '',
};

const adminTransaction = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminTransactionData: [],
  message: '',
};

const adminRefundsAndSettlement = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminRefundsAndSettlementData: [],
  message: '',
};

const adminRefunds = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminRefundsData: [],
  message: '',
};

const adminSettlements = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminSettlementsData: [],
  message: '',
};

const adminDownloadTransaction = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminDownloadTransactionData: [],
  message: '',
};

const bulkDownloadTransactions = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  bulkDownloadTransactionsData: [],
  message: '',
};

const adminPluralTransaction = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminPluralTransactionsData: [],
  message: '',
};

const adminEdgeTransaction = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  adminEdgeTransactionsData: [],
  message: '',
};

const acquirersState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const initialState = {
  adminTransaction: { ...adminTransaction },
  columnVisible: CUSTOMIZE_COLUMNS_CHECKBOX,
  selectedTab: 'TRANSACTION_DETAILS',
  adminRcuMerchant: { ...adminRcuMerchant },
  adminRefundsAndSettlement: { ...adminRefundsAndSettlement },
  adminDownloadTransaction: { ...adminDownloadTransaction },
  bulkDownloadTransactions: { ...bulkDownloadTransactions },
  adminPluralTransaction: { ...adminPluralTransaction },
  adminEdgeTransaction: { ...adminEdgeTransaction },
  acquirersState: { ...acquirersState },
  adminRefunds: { ...adminRefunds },
  adminSettlements: { ...adminSettlements },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function adminTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.POST_ADMIN_TRANSACTION_REQUEST:
      return {
        ...state,
        adminTransaction: {
          ...state.adminTransaction,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.POST_ADMIN_TRANSACTION_SUCCESS:
      return {
        ...state,
        adminTransaction: {
          ...state.adminTransaction,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminTransactionData: action.payload.body,
        },
      };

    case actionConstants.POST_ADMIN_TRANSACTION_FAILURE:
      return {
        ...state,
        adminTransaction: {
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_ADMIN_TRANSACTION_CLEAR:
      return {
        ...state,
        adminTransaction: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };

    case actionConstants.POST_ADMIN_REFUNDS_AND_SETTLEMENT_REQUEST:
      return {
        ...state,
        adminRefundsAndSettlement: {
          ...state.adminRefundsAndSettlement,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.POST_ADMIN_REFUNDS_AND_SETTLEMENT_SUCCESS:
      return {
        ...state,
        adminRefundsAndSettlement: {
          ...state.adminRefundsAndSettlement,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminRefundsAndSettlementData: action.payload.body,
        },
      };

    case actionConstants.POST_ADMIN_REFUNDS_AND_SETTLEMENT_FAILURE:
      return {
        ...state,
        adminRefundsAndSettlement: {
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_ADMIN_REFUNDS_AND_SETTLEMENT_CLEAR:
      return {
        ...state,
        adminRefundsAndSettlement: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };

    case actionConstants.POST_ADMIN_MERCHANT_REQUEST:
      return {
        ...state,
        adminRcuMerchant: {
          ...state.adminRcuMerchant,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.POST_ADMIN_MERCHANT_SUCCESS:
      return {
        ...state,
        adminRcuMerchant: {
          ...state.adminRcuMerchant,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminRcuMerchantData: action.payload.body,
        },
      };

    case actionConstants.POST_ADMIN_MERCHANT_FAILURE:
      return {
        ...state,
        adminRcuMerchant: {
          ...state.adminRcuMerchant,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_ADMIN_MERCHANT_CLEAR:
      return {
        ...state,
        adminRcuMerchant: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };

    case actionConstants.POST_ADMIN_COLUMN_VISIBLE_ACTION: {
      return {
        ...state,
        columnVisible: action.data.columnVisible,
        selectedTab: action.data.selectedTab,
      };
    }

    case actionConstants.ADMIN_DOWNLOAD_LIST_REQUEST: {
      return {
        ...state,
        adminDownloadTransaction: {
          ...state.adminDownloadTransaction,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    }

    case actionConstants.ADMIN_DOWNLOAD_LIST_SUCCESS: {
      return {
        ...state,
        adminDownloadTransaction: {
          ...state.adminDownloadTransaction,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminDownloadTransactionData: action.payload.body,
        },
      };
    }

    case actionConstants.ADMIN_DOWNLOAD_LIST_FAILURE: {
      return {
        ...state,
        adminDownloadTransaction: {
          ...state.adminDownloadTransaction,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.error_message,
        },
      };
    }

    case actionConstants.ADMIN_DOWNLOAD_LIST_CLEAR: {
      return {
        ...state,
        adminDownloadTransaction: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    }

    case actionConstants.BULK_DOWNLOAD_LIST_REQUEST: {
      return {
        ...state,
        bulkDownloadTransactions: {
          ...state.bulkDownloadTransactions,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    }

    case actionConstants.BULK_DOWNLOAD_LIST_SUCCESS: {
      return {
        ...state,
        bulkDownloadTransactions: {
          ...state.bulkDownloadTransactions,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          bulkDownloadTransactionsData: action.payload.body,
        },
      };
    }

    case actionConstants.BULK_DOWNLOAD_LIST_FAILURE: {
      return {
        ...state,
        bulkDownloadTransactions: {
          ...state.bulkDownloadTransactions,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.error_message,
        },
      };
    }

    case actionConstants.BULK_DOWNLOAD_LIST_CLEAR: {
      return {
        ...state,
        bulkDownloadTransactions: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    }

    case actionConstants.POST_PLURAL_TRANSACTION_API_REQUEST: {
      return {
        ...state,
        adminPluralTransaction: {
          ...state.adminPluralTransaction,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    }

    case actionConstants.POST_PLURAL_TRANSACTION_API_SUCCESS: {
      return {
        ...state,
        adminPluralTransaction: {
          ...state.adminPluralTransaction,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminPluralTransactionsData: action.payload.body,
        },
      };
    }

    case actionConstants.POST_PLURAL_TRANSACTION_API_FAILURE: {
      return {
        ...state,
        adminPluralTransaction: {
          ...state.adminPluralTransaction,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.error_message,
        },
      };
    }

    case actionConstants.POST_PLURAL_TRANSACTION_API_CLEAR: {
      return {
        ...state,
        adminPluralTransaction: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    }

    case actionConstants.POST_EDGE_TRANSACTION_API_REQUEST: {
      return {
        ...state,
        adminEdgeTransaction: {
          ...state.adminEdgeTransaction,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
    }

    case actionConstants.POST_EDGE_TRANSACTION_API_SUCCESS: {
      return {
        ...state,
        adminEdgeTransaction: {
          ...state.adminEdgeTransaction,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminEdgeTransactionsData: action.payload.body,
        },
      };
    }

    case actionConstants.POST_EDGE_TRANSACTION_API_FAILURE: {
      return {
        ...state,
        adminEdgeTransaction: {
          ...state.adminEdgeTransaction,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.error_message,
        },
      };
    }

    case actionConstants.POST_EDGE_TRANSACTION_API_CLEAR: {
      return {
        ...state,
        adminEdgeTransaction: {
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    }
    case actionConstants.GET_ACQUIRERS_REQUEST:
      return {
        ...state,
        acquirersState: {
          ...state.acquirersState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_ACQUIRERS_SUCCESS:
      return {
        ...state,
        acquirersState: {
          ...state.acquirersState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_ACQUIRERS_FAILURE:
      return {
        ...state,
        acquirersState: {
          ...state.acquirersState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.body.error_message,
        },
      };
    case actionConstants.GET_ACQUIRERS_CLEAR:
      return {
        ...state,
        acquirersState: {
          ...state.acquirersState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    
    case actionConstants.POST_ADMIN_REFUNDS_REQUEST:
      return {
        ...state,
        adminRefunds: {
          ...state.adminRefunds,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.POST_ADMIN_REFUNDS_SUCCESS:
      return {
        ...state,
        adminRefunds: {
          ...state.adminRefunds,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminRefundsData: action.payload.body,
        },
      };

    case actionConstants.POST_ADMIN_REFUNDS_FAILURE:
      return {
        ...state,
        adminRefunds: {
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.body.error_message,
        },
      };

      case actionConstants.POST_ADMIN_REFUNDS_CLEAR:
        return {
          ...state,
          adminRefunds: {
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            message: '',
          },
        };

    case actionConstants.POST_ADMIN_SETTLEMENTS_REQUEST:
      return {
        ...state,
        adminSettlements: {
          ...state.adminSettlements,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.POST_ADMIN_SETTLEMENTS_SUCCESS:
      return {
        ...state,
        adminSettlements: {
          ...state.adminSettlements,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          adminSettlementsData: action.payload.body,
        },
      };

    case actionConstants.POST_ADMIN_SETTLEMENTS_FAILURE:
      return {
        ...state,
        adminSettlements: {
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action.payload.body.error_message,
        },
      };

      case actionConstants.POST_ADMIN_SETTLEMENTS_CLEAR:
        return {
          ...state,
          adminSettlements: {
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            message: '',
        },
      };

    default:
      return state;
  }
}
